define('views/modules/calendar/activity/activity-panel',[
    // Libs
    'underscore', 'backbone', 'utils',
    // services
    'services/i18n',
    // Views
    'views/modules/calendar/calendar-item-panel',
    'views/modules/calendar/activity/detail/activity-detail-content',
    'views/modules/feedback/feedback',
    'views/modules/calendar/favorite/favorite-content',
], function(
    // Libs
    _, Backbone, U,
    // services
    i18n,
    // views
    VCalendarItemPanel,
    VActivityDetails,
    VFeedback,
    VFavoriteContent
) {

    var VActivityPanel = VCalendarItemPanel.extend({
        header: {
            title: "Activity",
            subtitle: "calendar:Create your custom activity",
        },
        content: {
            details: VActivityDetails,
            feedback: VFeedback,
            favorite: VFavoriteContent
        },
        tabs: [
            { id: 'details', title: 'Details', icon: 'sl-icon-info', active: true, callback: 'showDetails' },
            { id: 'feedback', title: 'calendar:Feedback', icon: 'sl-icon-bubbles', callback: 'showFeedback' },
            { id: 'favorite', title: 'Favorite', icon: 'sl-icon-star', callback: 'showFavorite' }
        ],

        initialize: function(opt) {
            this.view.layout.view.header.model.set('skipTranslation', true);
            this.listenTo(this.model, { 'sync change': this.onModelChange });
            VActivityPanel.__super__.initialize.apply(this, arguments);
        },

        // TABS
        showFavorite: function() {
            this.showContent('favorite', {
                type: "calendar-activity",
                // uses the dirty model from the item form view.
                model: this.view.details.model
            });
        },

        onModelChange: function(model) {
            var layout = this.view.layout,
                subtitle;

            if (!model.isNew()) {
                subtitle = i18n.t("calendar:This activity has been set by {{name}}", { "name": this.getAssignedBy(model) });
            }

            layout.setTitle(model.get('name') || i18n.t("Activity"));
            layout.setSubtitle(subtitle ? subtitle : i18n.t(this.getDefaultHeaderSubtitle()));
        },

        getAssignedBy: function(model) {
            if (model.get('garmin_summary_id')) {
                return 'Garmin';
            }

            return model.get('assignedBy');
        }

    });

    return VActivityPanel;
});

